// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M18 19h-2v-4h2Zm2-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2H2v2h12v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2h2v-2h-2Zm-7-5h-2V5h2Zm2-3V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2H2v2h7v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8h7V6Z"
    />
  </BaseIcon>
)
